'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _searchSuggestions = require('./remote/searchSuggestions');

var SearchSuggestions = {
    fetchSuggestions: _searchSuggestions.SearchSuggestionsRemote.fetchSuggestions
};

exports.default = SearchSuggestions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/searchSuggestions.js
// module id = v7uI
// module chunks = 60